import React from 'react';
import PropTypes from 'prop-types';
import {useDispatch} from 'react-redux';
import {I18n} from 'react-redux-i18n';
import classNames from 'classnames';
import _isEmpty from 'lodash/isEmpty';

import {withStyles} from '@material-ui/core/styles';
import {withRouter} from 'react-router-dom';

import PageviewIcon from '@material-ui/icons/Pageview';

import {
  GroupStatsCard,
  RenderDivOrEmpty,
} from '../index';
import {LoadingLayout} from '../../layouts-common';

import {TABS as clientsTabs} from '../../app-common/Clients/constants';
import {setFilter, setSearchOption} from '../../app-common/Insights/action';
import {FILTERS, TABS} from '../../app-common/Insights/constants';
import {PERIODS, ROUTES} from '../../constants';

import style from './style';

function ThreatStats(props) {
  const {
    classes,
    stats,
    widgetKey,
    history,
    canNavigate,
    selectedPeriodIndex,
    selectedCampusId,
    campuses,
  } = props;
  const dispatch = useDispatch();

  const threatData = stats.map((item) => {
    const countClasses = classNames(
      classes.part_count,
      {
        [classes.part_count_danger]: item.count > 0,
      },
    );
    return (
      <div key={item.threat} className={classes.item}>
        <span className={classes.part_threat}>{item.threat}</span>
        <span className={countClasses}>{item.count}</span>
      </div>
    );
  });

  const groupName = I18n.t(`clients.${clientsTabs.MANAGE}.editClientForm.threats.title`);

  return (
    <GroupStatsCard
      groupName={canNavigate ? (
        <div
          className={classes.titleWithAction}
          onClick={async() => {
            dispatch(
              setFilter(
                TABS.DOMAIN,
                FILTERS.CATEGORY_TYPE,
                {isApplied: true, value: 1}),
            );
            if (selectedCampusId) {
              const campus = campuses.find((c) => c.id === selectedCampusId);
              const index = campuses.findIndex((c) => c.id === selectedCampusId);
              dispatch(
                setFilter(
                  TABS.DOMAIN,
                  FILTERS.SITE,
                  {value: [{index, label: campus.name}], isApplied: true},
                ),
              );
            }
            dispatch(
              setSearchOption(
                TABS.DOMAIN,
                'period',
                Object.values(PERIODS)[selectedPeriodIndex],
              ),
            );
            history.push(ROUTES.INSIGHTS);
          }}
        >
          {groupName}
          <PageviewIcon />
        </div>
      ) : groupName}
      customCardClassName="card_fullHeight"
      customContentClasses={classes.cardContent}
      content={(
        <LoadingLayout widgetKey={widgetKey}>
          <RenderDivOrEmpty isShow={!_isEmpty(threatData)} className={classes.container}>
            {threatData}
          </RenderDivOrEmpty>
        </LoadingLayout>
      )}
    />
  );
}

ThreatStats.propTypes = {
  classes: PropTypes.object.isRequired,
  stats: PropTypes.array,
  widgetKey: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired,
  canNavigate: PropTypes.bool,
  selectedPeriodIndex: PropTypes.number,
  selectedCampusId: PropTypes.string,
  campuses: PropTypes.array,
};
ThreatStats.defaultProps = {
  stats: [],
  canNavigate: false,
  selectedPeriodIndex: 0,
  selectedCampusId: undefined,
  campuses: [],
};

export default withStyles(style)(withRouter(ThreatStats));
